export default __webpack_public_path__ + "static/media/homeLink.59a25041.svg";